import React from 'react';
import { Box, Flex, Text } from '@skin-seoul/design-system';
interface LoyaltyBannerDesktopProps {
  points: number;
  memberSince?: string;
  titleLine1?: string;
  titleLine2?: string;
  subtitle?: string;
  memberSinceLabel?: string;
  yourPointsLabel?: string;
  pointsUnit?: string;
}
export const LoyaltyBannerDesktop = ({
  points,
  memberSince,
  titleLine1 = 'Your',
  titleLine2 = 'SkinSociety',
  subtitle = 'Earn Points. Unlock Perks. Glow Every Step of the Way.',
  memberSinceLabel = 'Member\nSince',
  yourPointsLabel = 'Your Points',
  pointsUnit = 'Pts'
}: LoyaltyBannerDesktopProps) => {
  return <Box position="relative" width="100%" height="112px" borderRadius="8px" bgGradient="to-tl" gradientFrom="#311275" gradientTo="#754DCC" overflow="hidden" data-sentry-element="Box" data-sentry-component="LoyaltyBannerDesktop" data-sentry-source-file="LoyaltyBanner.Desktop.tsx">
      {/* Content */}
      <Flex position="relative" height="100%" alignItems="center" justifyContent="space-between" pl={4} pr={6} py={4} zIndex={1} data-sentry-element="Flex" data-sentry-source-file="LoyaltyBanner.Desktop.tsx">
        {/* Left Side - Title and Subtitle */}
        <Flex direction="column" gap={2} data-sentry-element="Flex" data-sentry-source-file="LoyaltyBanner.Desktop.tsx">
          <Flex direction="column" gap={0} data-sentry-element="Flex" data-sentry-source-file="LoyaltyBanner.Desktop.tsx">
            <Text as="span" color="primary.100" textStyle="heading.h6" fontWeight="bold" data-sentry-element="Text" data-sentry-source-file="LoyaltyBanner.Desktop.tsx">
              {titleLine1}{' '}
            </Text>
            <Text as="span" color="primary.100" textStyle="heading.h6" fontWeight="bold" data-sentry-element="Text" data-sentry-source-file="LoyaltyBanner.Desktop.tsx">
              {titleLine2}
            </Text>
          </Flex>
          <Text color="primary.100" textStyle="label.small" data-sentry-element="Text" data-sentry-source-file="LoyaltyBanner.Desktop.tsx">
            {subtitle}
          </Text>
        </Flex>

        {/* Right Side - Member Info and Points */}
        <Flex alignItems="center" gap={4} data-sentry-element="Flex" data-sentry-source-file="LoyaltyBanner.Desktop.tsx">
          {/* Member Since */}
          {memberSince && <>
              <Flex direction="column" gap={0.5}>
                <Text color="primary.300" textStyle="label.medium" fontWeight="semibold" whiteSpace="pre-wrap">
                  {memberSinceLabel}
                </Text>
                <Text color="primary.300" textStyle="label.small">
                  {memberSince}
                </Text>
              </Flex>

              {/* Vertical Separator */}
              <Box height="64px" width="1px" bg="primary.300" />
            </>}

          {/* Points */}
          <Flex direction="column" gap={1} data-sentry-element="Flex" data-sentry-source-file="LoyaltyBanner.Desktop.tsx">
            <Text color="primary.100" textStyle="label.small" data-sentry-element="Text" data-sentry-source-file="LoyaltyBanner.Desktop.tsx">
              {yourPointsLabel}
            </Text>
            <Text color="white" textStyle="heading.h6" fontWeight="extrabold" data-sentry-element="Text" data-sentry-source-file="LoyaltyBanner.Desktop.tsx">
              {points} {pointsUnit}
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </Box>;
};